<template>
  <div
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
  >
    <div
        class="bg-white rounded-lg w-full max-w-md mx-auto p-6 overflow-y-auto max-h-screen"
        @keydown.esc="cancel"
    >
      <h2 class="text-xl font-semibold mb-4">Edit List</h2>
      <div class="space-y-2">
        <!-- Make the list area scrollable -->
        <div class="overflow-y-auto max-h-96">
          <div
              v-for="(item, index) in currentValue"
              :key="index"
              class="flex items-center space-x-2 px-5"
          >
            <input
                type="text"
                v-model="currentValue[index]"
                @input="onInputChange"
                class="flex-grow p-2 border rounded"
            />
            <button
                @click="removeItem(index)"
                class="text-red-500 hover:text-red-700"
            >
              Remove
            </button>
          </div>
        </div>
      </div>
      <div class="mt-4 flex items-center space-x-2">
        <input
            type="text"
            v-model="newItem"
            @keydown.enter.prevent="addItem"
            placeholder="Add new item"
            class="flex-grow p-2 border rounded"
            ref="newItemInput"
        />
        <button
            @click="addItem"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Add
        </button>
      </div>
      <div class="mt-6 flex justify-end space-x-2">
        <button
            @click="cancel"
            class="px-4 py-2 rounded border hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
            @click="save"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import {nextTick} from "vue";

export default {
  name: 'ListEditor',
  props: ['params'],
  data() {
    return {
      currentValue: [],
      initialValue: [],
      newItem: '',
    };
  },
  created() {
    if( this.params.value !== null ) {
      this.currentValue = [...this.params.value].filter(item => item.trim() !== '');
      this.initialValue = [...this.currentValue];
    } else {
      this.currentValue = [];
      this.initialValue = [];
    }
  },
  mounted() {
    nextTick(() => {
      this.$refs.newItemInput.focus();
    });
  },
  methods: {
    getValue() {
      return this.currentValue;
    },
    isPopup() {
      return true;
    },
    addItem() {
      if (this.newItem.trim() !== '') {
        this.currentValue.push(this.newItem.trim());
        this.newItem = '';
        this.$nextTick(() => {
          this.$refs.newItemInput.focus();
        });
      }
    },
    removeItem(index) {
      this.currentValue.splice(index, 1);
    },
    save() {
      this.params.stopEditing();
    },
    cancel() {
      this.currentValue = [...this.initialValue];
      this.params.stopEditing();
    },
  },
};
</script>


<style scoped>
</style>